module.exports = __webpack_public_path__ + "assets/img/FormPiper-Landing-Page-+-Website.ad06de5c.jpg";